<template>
  <div>

    <exibir-processando v-if="processando"/>
    
    <div
      class="w3-modal"
      id="modal-selecionar-produto"
      style="display: block; padding:0px!important;"
      v-if="abrir_modal_selecionar_produto" 
      @click="abrir_modal_selecionar_produto = true">

      <div class="w3-modal-content w3-animate-zoom" @click.stop>
        <header class="w3-padding-small">
          <span 
            @click="fechar(false)" 
            class="w3-button w3-display-topright">&times;
          </span>
          <h4 class="titulo texto-vermelho">Pesquisar Produtos</h4>
        </header>

        <exibir-processando v-if="processando"/>

        <div class="w3-col s12 m12 l6 w3-padding" v-show="somentePesquisar == 'S'">
          <frame-cliente 
            ref="frCliente"
            :carregando_pedido="false"
            :permitido_trocar_cliente="true" 
            :buscar_financeiros_aberto="false"
            @limpar_cliente="limparCliente"
            @cliente_selecionado="adicionarCliente" 
          />
        </div>

        <div class="w3-col s12 m12 l6 w3-padding" v-show="somentePesquisar == 'S'">
          <frame-condicao-pagamento 
            ref="frCondicaoPagamento"
            somenteEmpresasLiberadas="S"
            liberadaClienteSimplificado="N"
            somenteLeitura="N"
            @limparDados="limparCondicaoPagamento"
            @confirmar="adicionarCondicaoPagamento" 
          />
        </div>    
        
        <div class="w3-margin-bottom">

          <div class="w3-row-padding w3-margin-bottom" v-if="mostrar_filtros_produtos">
            <div class="w3-col s12 m12 l12">
              <label v-if="indice_produto_pesquisa == 0">  Código</label>
              <label v-if="indice_produto_pesquisa == 2">  Código de barras</label> 
              <label v-if="indice_produto_pesquisa == 7">  Nome</label>
              <label v-if="indice_produto_pesquisa == 9">  Nome/Marca</label>

              <div v-if="indice_produto_pesquisa == 9" class="w3-row">
                <input
                  id="chave_produto_pesquisa"
                  ref="chave_produto_pesquisa"
                  class="w3-input w3-border w3-col s6 l6 m6" 
                  style="text-transform:uppercase"
                  autocomplete='off' 
                  v-model="chave_produto_pesquisa"
                  :type="[[ tipo_campo_pesquisa ]]"
                  :placeholder="[[ placeholder_produto ]]"
                  v-on:keyup.enter="buscarProdutos(false, false)"
                /> 
                <input 
                  :type="[[ tipo_campo_pesquisa ]]"
                  id="chave_produto_pesquisa_marca"
                  ref="chave_produto_pesquisa_marca"
                  style="text-transform:uppercase"
                  class="w3-input w3-border w3-col s6 l6 m6"
                  placeholder="Digite a marca"
                  autocomplete='off'
                  v-model="chave_produto_pesquisa_marca"  
                  v-on:keyup.enter="buscarProdutos(false, false)"
                /> 
              </div>

              <input
                id="chave_produto_pesquisa"
                ref="chave_produto_pesquisa"
                class="w3-input w3-border"
                style="text-transform:uppercase"
                autocomplete='off'
                :type="[[tipo_campo_pesquisa]]"
                :placeholder="[[ placeholder_produto ]]"
                v-model="chave_produto_pesquisa"
                v-if="indice_produto_pesquisa == 0 || indice_produto_pesquisa == 2 || indice_produto_pesquisa == 7"
                v-on:keyup.enter="buscarProdutos(false, false)" 
              />
            </div>

            <div class="w3-col s12 m12 l12 w3-left w3-margin-top">
              <input
                type="checkbox" 
                class="w3-check"
                id="exibirMultiploAvisoVenda"
                v-on:click="gravarConfiguracoesFiltros()"
                v-model="questionar_multiplo_aviso_venda"
              />
              <label :for="'exibirMultiploAvisoVenda'">Questionar múltiplo aviso de venda</label>
            </div> 
          
            <div class="w3-col s12 m12 l12 w3-left w3-margin-top" style="position: relative;">
              <div class="w3-dropdown-hover w3-left">
                <button
                  :disabled="processando"
                  class="w3-button w3-theme" 
                  style="margin-right: -10px;">
                  <i class="fa fa-filter"></i>
                </button>

                <div :disabled="processando" class="w3-dropdown-content w3-bar-block w3-border" style="width: 210px;">
                  <div>
                    <button 
                      :disabled="processando"
                      @click="setChaveProdutoPesquisa(0)"
                      class="w3-bar-item w3-button botao-quadrado">
                      <i :class="getIconeFiltroProduto(0)"></i>  Código
                    </button>
                  </div>
                
                  <div>
                    <button
                      :disabled="processando"
                      @click="setChaveProdutoPesquisa(2)"
                      class="w3-bar-item w3-button botao-quadrado">
                      <i :class="getIconeFiltroProduto(2)"></i>  Código de barras
                    </button>
                  </div>
                  
                  <div>
                    <button
                      :disabled="processando"
                      @click="setChaveProdutoPesquisa(7)"
                      class="w3-bar-item w3-button botao-quadrado">
                      <i :class="getIconeFiltroProduto(7)"></i>  Nome
                    </button>
                  </div>
                  
                  <div>
                    <button
                      :disabled="processando"
                      @click="setChaveProdutoPesquisa(9)"
                      class="w3-bar-item w3-button botao-quadrado">
                      <i :class="getIconeFiltroProduto(9)"></i>  Nome/Marca
                    </button>
                  </div>
                </div>
              </div>
          
              <div class="w3-col s9 m9 l9 w3-right">
                <button
                  @click="buscarProdutos(false, false)"
                  class="w3-button w3-theme w3-right" 
                  v-if="mostrar_filtros_produtos"
                  :disabled="processando">
                  <i class="fa fa-search"></i>
                  <span>Pesquisar</span>
                </button>
              </div>
          
              <div class="w3-col s12 m12 s12 w3-center" style="margin-top: 1px;">
                <i 
                  @click="mostrar_filtros_produtos = false"
                  class='fas fa-caret-down w3-center'
                  style='font-size:24px; cursor: pointer;'
                  v-if="produtos_filtrados.length > 0 && mostrar_filtros_produtos && !processando">
                </i>  
              </div>
            </div>
          </div>

          <div class="w3-col s12 m12 l12 w3-left w3-padding-small">
            <button 
              class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile" 
              v-if="!mostrar_filtros_produtos"
              :disabled="processando"
              v-on:click="mostrar_filtros_produtos = !mostrar_filtros_produtos">
              <i class="fa fa-filter icone-vermelho"></i> Mostrar filtros
            </button>
          </div>

          <div class="w3-row-padding" v-if="!mostrar_filtros_produtos && produtos_filtrados.length > 0">
      
            <div style="max-height: calc(75vh - 150px); min-height: 200px; overflow: auto">
          
              <div
                :key="index"
                v-for="(produto, index) in produtos_filtrados"
                v-show="(index >= (pagina_atual * qtd_produtos_por_pagina) - qtd_produtos_por_pagina) && (index < (pagina_atual * qtd_produtos_por_pagina))">
                
                <div 
                  class="w3-panel w3-card card-produto w3-col s12 m12 l12" 
                  :class="{'active' :produto.mostrar_detalhes}" 
                  :style="getStiloCardProdutos(produto)">

                  <legenda v-if="produto.kit == 'S'">
                    <span>KIT</span>
                    <i slot="referencia" style="color: #ffeb3b" class="fa fa-circle"></i>
                  </legenda>

                  <legenda v-if="produto.produto_tem_preco_quantidade == 'S'">
                    <span>Produto tem preço por quantidade</span>
                    <i slot="referencia" style="color: #ff5722" class="fa fa-circle"></i>
                  </legenda>
                  
                  <div 
                    class="w3-col l12 s12 m12 w3-left" 
                    @click="alternarDetalhesProdutoPesquisado(produto.produto_id)">
                    
                    <div class="w3-col s12 m9 l9">
                      <strong 
                        class="texto-vermelho titulo" 
                        style="font-size: 15px !important; color: w3-theme">
                        {{formatarValor(produto.produto_id, 0)}} - {{produto.nome}} 
                      </strong> 
                      
                      <strong 
                        class="texto-vermelho titulo" 
                        style="font-size: 15px !important; color: w3-theme">
                        - ({{produto.unidade}})
                      </strong>
                      <label style="font-size: 12px !important;"><br> {{produto.marca}}</label>

                      <div class="w3-col s12 m12 l12">
                        <div class="w3-col s12 m6 l4">
                          <label
                            class="switch" 
                            style="padding: 12px!important; width:160px!important;"
                            v-if="mostrarOpcaoPrecoAtacado(produto)">
                            
                            <input 
                              type="checkbox" 
                              :disabled="desabilitarOpcaoPreco(produto, 'ATA')" 
                              v-model="produto.ativar_preco_atacado" 
                              @click="utilizarPrecoAtacado(index)">
                              
                            <span class="slider-atacado round-atacado">
                              <strong style="margin-left: 26%;">Preço de atacado</strong>
                            </span>
                          </label>
                        </div>
                        
                        <div class="w3-col s12 m6 l4">
                          <label
                            class="switch" 
                            style="padding: 12px!important; width:160px!important;"
                            v-if="mostrarOpcaoPontaEstoque(produto)">
                            <input 
                              type="checkbox" 
                              :disabled="desabilitarOpcaoPreco(produto, 'PON')"
                              v-model="produto.ponta_estoque" @click="utilizarPontaEstoque(index)">
                              
                            <span class="slider round"><strong style="margin-left: 26%; ">Ponta de estoque</strong></span>
                          </label>
                        </div>
                        
                        <div class="w3-col s12 m6 l4">
                          <label 
                            class="switch" 
                            style="padding: 12px!important; width:160px!important;"
                            v-if="mostrarOpcaoPromocao(produto, 'NOR')">
                            <input 
                              type="checkbox" 
                              :disabled="desabilitarOpcaoPreco(produto, 'NOR')" 
                              v-model="produto.promocao" @click="utilizarPromocao(index, 'NOR')">
                              
                            <span class="slider-promocao round-promocao"><strong style="margin-left: 36%;">Promoção</strong></span>
                          </label>
                        </div>
                        
                        <div class="w3-col s12 m6 l4">
                          <label 
                            class="switch" 
                            style="padding: 12px!important; width:172px!important;"
                            v-if="mostrarOpcaoPromocao(produto, 'ESP')">
                            <input 
                              type="checkbox"
                              :disabled="desabilitarOpcaoPreco(produto, 'ESP')"
                              v-model="produto.promocao" 
                              @click="utilizarPromocao(index, 'ESP')">
                              
                            <span class="slider-promocao-especial round-promocao-especial">
                              <strong style="margin-left: 25%;">Promoção especial</strong>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="w3-col s12">
                      <label class="w3-margin-right">
                        Estoque ato: <strong>{{formatarValor(produto.estoque_ato)}}</strong>
                      </label>
                    </div>

                    <div class="w3-col s12">
                      <label class="w3-margin-right">
                        Estoque agendamento: <strong>{{formatarValor(produto.estoque_agendamento)}}</strong> 
                      </label>
                    </div>

                    <div class="w3-col s12">
                      <label>Preço com impostos: </label>
                      <label class="w3-margin-right">
                        <strong 
                          v-if="!produto.processando_imposto" 
                          style="color: #498a4c;">
                          R$ {{formatarValor(produto.preco_unitario_com_imposto, 4)}}
                        </strong>
                        
                        <span v-if="produto.processando_imposto">
                          <i class="fas fa-spinner fa-pulse"></i>
                        </span>
                      </label>
                    </div> 
                  </div>
            
                  <div class="w3-col l6 s12 m12">
                    <div class="w3-col s10 m12" @click="alternarDetalhesProdutoPesquisado(produto.produto_id)">                          
                      <div v-if="produto.preco_promocao > 0" class="w3-col s12 m6 l6">
                        <label>Preço promoção: </label>
                        <label class="w3-margin-right">
                          <strong>R$ {{formatarValor(produto.preco_promocao, 2)}}</strong>
                        </label><br> 
                      </div>
                    </div>
                  </div>
            
                  <div class="w3-col" v-show="produto.mostrar_detalhes">
                    <div class="w3-col l12 s12 m12 w3-left w3-margin-bottom">
                      <div class="w3-col s12 m12 l11">
                        <div class="w3-col s12 m12 l12">
                          <div class="w3-col s12 m12 l4">
                            <label>Preço: </label>
                            <label 
                              class="w3-margin-right">
                              <strong :style="getStyleProduto(produto)">R$ {{formatarValor(produto.preco, 2)}}</strong>
                            </label>
                          </div>  
                          
                          <div class="w3-col s12 m12 l4">
                            <label>Código original: </label>
                            <label class="w3-margin-right">
                              <strong>{{produto.codigo_original}}</strong>
                            </label>
                          </div>
                        </div>
                        
                        <div class="w3-col s12 m12 l12"> 
                          <div class="w3-col s12 m7 l4">
                            <label>Cód. de barras: </label>
                            <label class="w3-margin-right"><strong>{{produto.codigo_barras}}</strong></label>
                          </div>
                          
                          <div class="w3-col s12 m5 l4">
                            <label>Múltiplo de venda: </label>
                            <label class="w3-margin-right"><strong>{{produto.multiplo_venda}}</strong></label>
                          </div>
                          
                          <div class="w3-col s12 m5 l4">
                            <label>Múltiplo de aviso: </label>
                            <label class="w3-margin-right"><strong>{{produto.multiplo_venda_aviso_venda}}</strong></label>
                          </div>
                        </div>
                        
                        <div class="w3-col s12 m12 l12 w3-marggin-top w3-margin-bottom">                                
                          <div class="w3-col s5 m5 l3" style="margin-right: 10px !important" v-show="somentePesquisar == 'N'">
                            <input 
                              min="0"
                              type="number"
                              class="w3-input"
                              style="text-transform:uppercase"
                              v-focus='produto.mostrar_detalhes'
                              id="quantidade_pesquisa"
                              ref="quantidade_pesquisa"
                              placeholder="Digite a quantidade"
                              :disabled="processando_imposto"
                              v-model="produto.quantidade_edicao" 
                              v-on:keyup="recalcularImpostosProdutoSelecionado([index], false, (produto.produto_tem_preco_quantidade == 'N'), 'MANTER_PERCENTUAL')"
                              v-on:keyup.enter="adicionar(produto)"
                            />
                          </div>
                          
                          <button
                            v-show="somentePesquisar == 'N'"
                            style="margin-bottom: 8px !important;"
                            class="w3-button w3-green w3-col s3 m3 l3 btn-qtd"
                            :disabled="processando_imposto || produto.processando_imposto"
                            @click="adicionar(produto)">
                            <i class="fas fa-check"></i>
                          </button>

                          <div v-show="somentePesquisar == 'S'" style="margin-top: 8px; margin-bottom: 5px;"/>
                          
                          <button 
                            style="margin-left: 8px !important;"
                            class="w3-button w3-theme w3-col s3 m3 l3 btn-qtd"
                            :disabled="permitirDesconto(produto) || produto.processando_imposto"
                            @click="abrirCalcularDescontoProduto(produto, index)">
                            <i class="fa fa-edit"></i>
                          </button>
                        </div>
                        
                        <div class="w3-col s12 m12 l12 w3-center">
                          <div class="w3-col s3 m3 l1">
                            <button 
                              title="Características do produto" 
                              class="w3-button botoes-cinza"
                              @click="exibirCaracteristicasProduto(produto)">
                              <i class="fa fa-info-circle" aria-hidden="true"></i>                            
                            </button>
                          </div>
                          
                          <div class="w3-col s3 m3 l1">
                            <button 
                              title="Verificar estoque da rede"
                              class="w3-button botoes-cinza"
                              style="margin-bottom: 5px !important;"
                              @click="exibirEstoqueRedeProduto(produto)">
                              <i class="fas fa-cubes" aria-hidden="true"></i>
                            </button>
                          </div>
                          
                          <div class="w3-col s3 m3 l1">
                            <button 
                              title="Assistência técnica"
                              class="w3-button botoes-cinza"
                              @click="exibirAssistenciasTecnicas(produto)">
                              <i class="fas fa-hammer" aria-hidden="true"></i>
                            </button>
                          </div>
                          
                          <div class="w3-col s3 m3 l1">
                            <button 
                              title="Dados de produtos vendidos"
                              class="w3-button botoes-cinza"
                              @click="exibirDadosProdutosVendidos(produto)">
                              <i class="fas fa-chart-line" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w3-col l12 w3-center w3-margin-top" v-if="mostrar_botao_ver_mais">
                <button
                  :disabled="processando"
                  class="w3-button w3-theme"
                  v-on:click="buscarProdutos(false, true)">
                  <span>Ver mais..</span>
                </button>
              </div>

            </div>

            <div 
              data-div="paginacao"
              class="w3-margin-top w3-row"
              v-if="
              ( 
                (!processando) &&
                (!mostrar_filtros_produtos) &&
                (produtos_filtrados) && 
                (produtos_filtrados.length > 0) &&
                (total_paginas > 1)
              )">

              <button 
                data-button="botao-angle-left"
                class="w3-col w3-btn w3-blue-grey s2 m1 menu-paginacao" 
                @click="pagina_atual = 1" 
                :disabled="pagina_atual == 1">
                <i data-i="botao-angle-left" class="fa fa-angle-double-left"></i>
              </button>
                
              <button 
                data-button="botao-angle-left"
                style="margin-left: 5px;"
                class="w3-col w3-btn w3-dark-grey s2 m1 menu-paginacao" 
                @click="pagina_atual -= 1" 
                :disabled="pagina_atual == 1">
                <i data-i="botao-angle-left" class="fa fa-angle-left"></i>
              </button>
                
              <button 
                data-button="botao-angle-right"
                style="margin-left: 5px;!important"
                class="w3-col w3-btn w3-dark-grey s2 m1 menu-paginacao" 
                @click="pagina_atual += 1" 
                :disabled="pagina_atual == total_paginas">
                <i data-i="botao-angle-right" class="fa fa-angle-right"></i>
              </button>
                
              <button
                data-button="botao-double-right" 
                style="margin-left: 5px;"
                class="w3-col w3-btn w3-blue-grey s2 m1 menu-paginacao" 
                @click="pagina_atual = total_paginas" 
                :disabled="pagina_atual == total_paginas">
                <i data-i="botao-double-right" class="fa fa-angle-double-right"></i>
              </button>
              
              <strong 
                data-strong="numero-pagina"
                class="w3-right">
                {{pagina_atual}} / {{total_paginas}}
              </strong>
            </div>

            <modal-calcular-desconto-produto 
              v-if="mostrar_desconto_produto" 
              :produtoSelecionado="produto_selecionado"
              :percentualDescontoMaximoF5="percentualDescontoMaximoF5"
              :parEmpGerarBloqDescF5AcimaAut="parEmpGerarBloqDescF5AcimaAut"
              @alterar="aplicarDescontoProduto"
              @fechar="mostrar_desconto_produto = false"
            />

            <dados-produtos-vendidos 
              style="z-index:200;" 
              ref="dadosProdutosVendidos"
            />

            <modal-caracteristicas-produto 
              ref="mdCaracteristicasProduto"
            />
            
            <modal-estoque-rede-produto 
              ref="mdEstoqueRedeProduto"
            /> 
            
            <modal-assistencia-tecnica 
              ref="mdAssistenciaTecnica"
            />

          </div>
        </div>
      </div>
    </div><!-- Fim modal de Produtos  -->
  </div>
</template>
<script>
// import componentes vue
import VueNumeric from 'vue-numeric'
import Legenda from '@/components/Legendas'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import ExibirProcessando from '@/components/ExibirProcessando'
import FrameCliente from '@/components/Frames/FrameClienteOrcamento'
import FrameCondicaoPagamento from '@/components/Frames/FrameCondicaoPagamento'
import DadosProdutosVendidos from '@/components/Orcamentos/DadosProdutosVendidos'
import ModalAssistenciaTecnica from '@/components/Orcamentos/ModalAssistenciaTecnica' 
import ModalEstoqueRedeProduto from '@/components/Orcamentos/ModalEstoqueRedeProduto'
import ModalCaracteristicasProduto from '@/components/Orcamentos/ModalCaracteristicasProduto'
import ModalCalcularDescontoProduto from '@/components/Orcamentos/ModalCalcularDescontoProduto'

// import java script
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import RProdutoBuscarProdutoOrcamento from '@/components/Rest/RProduto/RProdutoBuscarProdutoOrcamento.js'
import ROrcamentoReprocessarProdutos from '@/components/Rest/ROrcamento/ROrcamentoReprocessarProdutos.js'

import { focus } from 'vue-focus';

export default {
    directives: { focus: focus },
    name: 'PesquisaProdutosVenda',

    components: {
      Legenda, 
      VueNumeric, 
      FrameCliente,
      ExibirProcessando,
      DadosProdutosVendidos,
      FrameCondicaoPagamento,
      ModalAssistenciaTecnica,
      ModalEstoqueRedeProduto,
      ModalCaracteristicasProduto, 
      ModalCalcularDescontoProduto,
    },
    
    props:{
      condicaoSelecionada: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      clienteSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      enderecoClienteSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },

      outrasDespesas: {
        required: false,
        type: Number,
        default: 0
      },

      totalProdutos: {
        required: false,
        type: Number,
        default: 0
      },

      totalFrete: {
        required: false,
        type: Number,
        default: 0
      },

      tipoFrete: {
        required: false,
        type: String,
        default: 'F'
      },

      valorFrete: {
        required: false,
        type: Number,
        default: 0
      },

      tipoEntrega: {
        required: false,
        type: String,
        default: 'ATO'
      },

      parGerQtdMinCaractPesqProdutos: {
        required: true,
        type: Number,
        default: 3
      },

      parEmpQuestionarUsoPromocao: {
        required: true,
        type: String,
        default: function () {
          return {}
        }
      },

      parEmpQuestionarUsoPrecoAtacadoVda: {
        required: true,
        type: String,
        default: function () {
          return {}
        }
      },

      parEmpGerarBloqDescF5AcimaAut: {
        required: true,
        type: String,
        default: function () {
          return {}
        }
      },

      percentualDescontoMaximoF5: {
        required: true,
        type: Number,
        default: 0
      },

      produtosSelecionados: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },

      adicionarProduto: {
        required: false,
        type: Function,
        default: function () {
          return {}
        }
      },

      somentePesquisar: {
        required: true,
        type: String,
        default: 'N'
      },
    },
    
    mixins:[formatarValorMixin],
    data () {
      return {
        api: process.env.API,
        mostrar_filtros_produtos: true,
        chave_produto_pesquisa_marca: '',
        processando: false,
        questionar_multiplo_aviso_venda: true,
        processando_imposto: false,
        mostrar_desconto_produto: false,
        produtos_filtrados: [],
        abrir_modal_selecionar_produto: false,
        chave_produto_pesquisa: '',
        placeholder_produto: 'Digite o nome',
        tipo_campo_pesquisa: 'text',
        indice_produto_pesquisa: 9,
        produto_selecionado: {},
        produtos_ja_mostrados_ids: [],
        qtd_produtos_por_pagina: 85,
        pagina_atual: 1,
        total_paginas: 0,
        mostrar_botao_ver_mais: 'N',
        adicionado_direto: false,
        localStorage: {},
      }
    },
    
    watch:{
      abrir_modal_assistencia_tecnica() {
        this.verificarModalAberto()   
      },  
    },
    
    methods:{
      exibirDadosProdutosVendidos(produto){
        this.$refs.dadosProdutosVendidos.exibirModal(produto.produto_id, this.clienteSelecionado.cadastro_id);
      },

      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        } 
      },

      async adicionar(produto){
        produto.foi_adicionado = false;
        produto.questionar_multiplo_aviso_venda = this.questionar_multiplo_aviso_venda;
        
        await this.adicionarProduto(produto);
        this.getStiloCardProdutos(produto);

        if (produto.foi_adicionado){
          produto.mostrar_detalhes = false;

		      if (this.adicionado_direto){
            this.abrir_modal_selecionar_produto = false;
            this.limparPesquisa(true);
          }
        }
      },

      getStiloCardProdutos(produto){
        if(produto.foi_adicionado){
          return 'background-color: #d2f9c5;cursor: pointer';
        }else{
          return 'cursor: pointer';
        }
      },

      exibirCaracteristicasProduto(produto){
        this.$refs.mdCaracteristicasProduto.exibirModal(produto);
      },

      exibirEstoqueRedeProduto(produto){
        this.$refs.mdEstoqueRedeProduto.exibirModal(produto);
      },

      exibirAssistenciasTecnicas(produto){
        this.$refs.mdAssistenciaTecnica.exibirModal(produto);
      },

      abrirCalcularDescontoProduto(produto){
        this.produto_selecionado = {};
        this.produto_selecionado = JSON.parse(JSON.stringify(produto));
        
        if (isNaN(this.produto_selecionado.preco_venda_sem_desconto)){
          this.produto_selecionado.preco_venda_sem_desconto = Biblioteca.valor(this.produto_selecionado.preco_venda_sem_desconto);
        }

        this.mostrar_desconto_produto = true;
      },

      linhaProdutoSelecionado(produto_id){
        let linha = -1;

        for (let i = 0; i < this.produtos_filtrados.length; i++) {
          if (this.produtos_filtrados[i].produto_id == produto_id) {
            linha = i;
            break;
          }
        }

        return linha;
      },
    
      async aplicarDescontoProduto(produto){ 
        if (!produto){
          Biblioteca.exclamar('Nenhum produto foi selecionado para aplicar o desconto!');
          return;
        }
        
        if (parseFloat(produto.perc_desconto_temp) > parseFloat(this.desconto_autorizado_vendedor)){
          Biblioteca.exclamar(
            'Usuário não autorizado a dar este desconto! ' + 
            'Desconto dado: ' +
            this.formatarValor(produto.perc_desconto_temp, 4) + 
            '%. ' +
            'Produto: ' + 
            produto.produto_id
          );
          return; 
        }

        let index = this.linhaProdutoSelecionado(produto.produto_id); 

        if (index == -1){
          Biblioteca.exclamar('Nenhum produto encontrado para aplicar o desconto!');
          return;
        }

        produto.ponta_estoque = false;

        if (produto.perc_desconto_temp == 0 || produto.perc_desconto_temp == ''){
          produto.perc_desconto = 0;
          produto.valor_desconto = 0;
          produto.desconto_alterado = false;
        } else {
          produto.perc_desconto = produto.perc_desconto_temp;
          produto.valor_desconto = this.Arredondar(produto.valor_desconto_temp, 2);
          produto.desconto_alterado = true;
        }

        this.produtos_filtrados[index] = JSON.parse(JSON.stringify(produto));
        
        if (produto.valor_desconto == 0){
          this.produtos_filtrados[index].preco_alterado = false;
        } else{
          this.produtos_filtrados[index].preco_alterado = true;
        }

        this.produtos_filtrados[index].preco_manual = (produto.preco_venda_sem_desconto - Biblioteca.valor(produto.valor_desconto));
        this.produtos_filtrados[index].preco = this.Arredondar(this.produtos_filtrados[index].preco_manual, 2);
        this.produtos_filtrados[index].valor_desconto = produto.valor_desconto;
        
        await this.recalcularImpostosProdutoSelecionado([index], true, false, 'MANTER_VALOR');         
        this.mostrar_desconto_produto = false;
      },

      async recalcularImpostosProdutoSelecionado(produtos_index, mostrar_processando_imposto, sair_reprocessamento, tipo_negociacao_preco){
        try {

          if (sair_reprocessamento){
            return;
          }

          if (!produtos_index){
            Biblioteca.exclamar('Nenhuma linha foi selecionada para recalcular os impostos!');
            return;
          }

          if (mostrar_processando_imposto){
            this.processando_imposto = true;
          }
          
          let produtos_recalculando = [];

          for (let i = 0; i < produtos_index.length; i++){
            this.produtos_filtrados[produtos_index[i]].processando_imposto = true;

            produtos_recalculando.push(            
              {
                P1: 0,
                P2: Biblioteca.valor(this.produtos_filtrados[produtos_index[i]].quantidade_edicao) > 0 ? this.formatarValor(this.produtos_filtrados[produtos_index[i]].quantidade_edicao) : this.produtos_filtrados[produtos_index[i]].multiplo_venda,
                P3: this.produtos_filtrados[produtos_index[i]].usou_promocao,
                P4: this.formatarValor(this.produtos_filtrados[produtos_index[i]].preco_base),
                P5: this.produtos_filtrados[produtos_index[i]].produto_id,
                P6: this.formatarValor(this.produtos_filtrados[produtos_index[i]].perc_desconto),
                P7: this.formatarValor(this.produtos_filtrados[produtos_index[i]].preco),
                P8: this.formatarValor(this.produtos_filtrados[produtos_index[i]].valor_desconto),
                P9: this.produtos_filtrados[produtos_index[i]].ponta_estoque ? 'S' : 'N',
                P10: this.produtos_filtrados[produtos_index[i]].usou_preco_atacado,
                P11: this.produtos_filtrados[produtos_index[i]].retirar_lojas_rede,
                P12: this.produtos_filtrados[produtos_index[i]].desconto_alterado ? 'S' : 'N',
                P13: this.produtos_filtrados[produtos_index[i]].quantidade_agendar,
                P14: this.produtos_filtrados[produtos_index[i]].usou_promocao_especial,
                P15: this.produtos_filtrados[produtos_index[i]].qtd_sem_agendamento,
                P16: this.produtos_filtrados[produtos_index[i]].quantidade_entrega_ato,
                P17: this.produtos_filtrados[produtos_index[i]].quantidade_sem_previsao,
                P18: this.produtos_filtrados[produtos_index[i]].tipo_selec_local_entrega_ato,
                P19: this.produtos_filtrados[produtos_index[i]].previsao_entrega_sem_agen,
                P20: this.produtos_filtrados[produtos_index[i]].quantidade_entrega_ato_loj,
                P21: this.produtos_filtrados[produtos_index[i]].quantidade_entrega_ato_dep,
                P22: this.produtos_filtrados[produtos_index[i]].quantidade_entrega_ato_exp,
                P23: this.produtos_filtrados[produtos_index[i]].tipo_local_padrao_entrega_ato,
                P24: this.produtos_filtrados[produtos_index[i]].usou_indice_grupo_indice_preco,
                P25: this.produtos_filtrados[produtos_index[i]].empresa_retirar_lojas_rede_id,
                P26: this.produtos_filtrados[produtos_index[i]].tipo_uso_preco_por_quantidade,
              }
            )
          }

          let parametros = {
            produtos_recalculando: produtos_recalculando,
            condicao_pagamento_id: this.condicaoSelecionada.condicao_id,
            cliente_id: this.clienteSelecionado.cadastro_id,
            bairro_id: this.enderecoClienteSelecionado.bairro_id,
            cep: this.enderecoClienteSelecionado.cep,
            tipo_imovel: this.enderecoClienteSelecionado.tipo_imovel,
            andar: this.enderecoClienteSelecionado.andar,
            inscricao_estadual: this.enderecoClienteSelecionado.inscricao_estadual,
            outras_despesas: this.outrasDespesas,
            total_frete: this.totalFrete,
            tipo_frete: this.tipoFrete,
            valor_frete: this.valorFrete,
            tipo_entrega: this.tipoEntrega,
            tipo_negociacao_preco: tipo_negociacao_preco ? tipo_negociacao_preco : 'NENHUM'
          }

          this.$forceUpdate();

          let retorno = await ROrcamentoReprocessarProdutos.reprocessarProdutos(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          for (let i = 0; i < retorno.dados.produtos.length; i++){
            
            for (let j = 0; j < produtos_index.length; j++){

              if (Biblioteca.valorInt(retorno.dados.produtos[i].produto_id) == Biblioteca.valorInt(this.produtos_filtrados[produtos_index[j]].produto_id)){
                
                this.produtos_filtrados[produtos_index[j]].preco_unitario_com_imposto = Biblioteca.valor(retorno.dados.produtos[i].preco_unitario_com_imposto);
                this.produtos_filtrados[produtos_index[j]].preco_manual = Biblioteca.valor(retorno.dados.produtos[i].preco_venda_sem_desconto) - Biblioteca.valor(retorno.dados.produtos[i].valor_desconto);
                this.produtos_filtrados[produtos_index[j]].preco_base = Biblioteca.valor(retorno.dados.produtos[i].preco_base);
                this.produtos_filtrados[produtos_index[j]].preco = this.produtos_filtrados[produtos_index[j]].preco_manual;
                this.produtos_filtrados[produtos_index[j]].preco_temp = this.produtos_filtrados[produtos_index[j]].preco;

                this.produtos_filtrados[produtos_index[j]].perc_desconto = Biblioteca.valor(retorno.dados.produtos[i].perc_desconto);
                this.produtos_filtrados[produtos_index[j]].valor_desconto = Biblioteca.valor(retorno.dados.produtos[i].valor_desconto);
                this.produtos_filtrados[produtos_index[j]].perc_desconto_temp = this.produtos_filtrados[produtos_index[j]].perc_desconto;
                this.produtos_filtrados[produtos_index[j]].valor_desconto_temp = this.produtos_filtrados[produtos_index[j]].valor_desconto;

                this.produtos_filtrados[produtos_index[j]].preco_atacado = Biblioteca.valor(retorno.dados.produtos[i].preco_atacado);
                this.produtos_filtrados[produtos_index[j]].preco_ponta = Biblioteca.valor(retorno.dados.produtos[i].preco_ponta);
                this.produtos_filtrados[produtos_index[j]].preco_atacado_oculto = Biblioteca.valor(retorno.dados.produtos[i].preco_atacado_oculto);
                this.produtos_filtrados[produtos_index[j]].preco_promocao = Biblioteca.valor(retorno.dados.produtos[i].preco_promocao);
                this.produtos_filtrados[produtos_index[j]].preco_venda_oculto = Biblioteca.valor(retorno.dados.produtos[i].preco);
                
                this.produtos_filtrados[produtos_index[j]].tipo_promocao = retorno.dados.produtos[i].tipo_promocao;
                this.produtos_filtrados[produtos_index[j]].preco_venda_sem_desconto = Biblioteca.valor(retorno.dados.produtos[i].preco_venda_sem_desconto);
                
                // Preço auxiliar
                this.produtos_filtrados[produtos_index[j]].preco_aux = Biblioteca.valor(retorno.dados.produtos[i].preco);
                this.produtos_filtrados[produtos_index[j]].preco_venda_oculto_aux = Biblioteca.valor(retorno.dados.produtos[i].preco_venda_oculto);
                this.produtos_filtrados[produtos_index[j]].preco_unitario_com_imposto_aux = Biblioteca.valor(retorno.dados.produtos[i].preco_unitario_com_imposto);
                this.produtos_filtrados[produtos_index[j]].preco_base_aux = Biblioteca.valor(retorno.dados.produtos[i].preco_base);
                this.produtos_filtrados[produtos_index[j]].tipo_uso_preco_por_quantidade = retorno.dados.produtos[i].tipo_uso_preco_por_quantidade;

                break; 
              }
            }
          }

          this.processando_imposto = false;

          for (let i = 0; i < produtos_index.length; i++){
            this.produtos_filtrados[produtos_index[i]].processando_imposto = false;
          }

          this.$forceUpdate();
        } catch (error) {
          for (let i = 0; i < produtos_index.length; i++){
            this.produtos_filtrados[produtos_index[i]].processando_imposto = false;
          }

          this.$forceUpdate();
          this.verificarErro(error, 'recalcularImpostosProdutoSelecionado');  
        }     
      },

      getStyleProduto(produto){
        if (produto.preco_alterado == undefined)  {
          return '';
        } else if (produto.preco_alterado){
          return 'color: blue';
        }
      },
    
      async alternarDetalhesProdutoPesquisado(produto_id){
        let indice = this.linhaProdutoSelecionado(produto_id);

        if (indice == -1) {
          return;
        }

        this.produtos_filtrados[indice].mostrar_detalhes = !this.produtos_filtrados[indice].mostrar_detalhes;  

        for (let i = 0; i < this.produtos_filtrados.length; i++){
          if (Biblioteca.valorInt(this.produtos_filtrados[i].produto_id) != Biblioteca.valorInt(this.produtos_filtrados[indice].produto_id)){
            this.produtos_filtrados[i].mostrar_detalhes = false;
          }
        }

        this.produtos_filtrados = JSON.parse(JSON.stringify(this.produtos_filtrados));

        if (this.produtos_filtrados[indice].recalcular_preco_imposto) {
          await this.recalcularImpostosProdutoSelecionado([indice], true);
          this.produtos_filtrados[indice].recalcular_preco_imposto = false;
        }  
      },

      getIconeFiltroProduto: function(indice) {
        if (indice === this.indice_produto_pesquisa) {
          return 'fa fa-check-square icone-vermelho';
        } else {
          return 'far fa-square';
        }
      },

      setChaveProdutoPesquisa: function(indice) {
        if (Biblioteca.em(indice, ['0', '2'])) {
          this.tipo_campo_pesquisa = "number";
        } else {
          this.tipo_campo_pesquisa = "text";
        }

        this.indice_produto_pesquisa = indice;
        this.chave_produto_pesquisa = "";
        this.chave_produto_pesquisa_marca = "";
        this.setPlaceHolder(indice);
        this.$nextTick(() => this.$refs.chave_produto_pesquisa.focus());
      },

      setPlaceHolder(indice){
        this.placeholder_produto = '';

        if (indice == 7 || indice == 9) {
          this.placeholder_produto ='Digite o nome';
        }
      },

      async mostrarModalProdutos(adicionado_direto){
        if (this.somentePesquisar == 'N'){
          if (!this.clienteSelecionado.cadastro_id){
            Biblioteca.exclamar('Para pesquisar o preço é necessário informar o cliente!')
            return;
          }
          
          if (!this.condicaoSelecionada.condicao_id){
            Biblioteca.exclamar('Para pesquisar o preço é necessário informar a condição de pagamento!')
            return;
          }
          
          this.buscarFiltrosDefinidosLocalStorage();
        } else {
          this.limparPesquisa(true);
        }
        
        this.abrir_modal_selecionar_produto = true;
		    this.adicionado_direto = adicionado_direto;

        if (!adicionado_direto && this.mostrar_filtros_produtos){
          this.$nextTick(() => this.$refs.chave_produto_pesquisa.focus());
        }
      },

      fechar(limpar_pesquisa){
        this.abrir_modal_selecionar_produto = false;

        if (limpar_pesquisa){
          this.limparPesquisa(true);
        }
      },

      permitirDesconto(produto){
        if (
          produto.usou_promocao == 'S' ||
          produto.usou_promocao_especial == 'S' ||
          produto.ponta_estoque ||
          this.processando_imposto
        )
          return true;
        else 
          return false;
      },

      desfazerAlteracaoPrecoProduto(index, tipo_alteracao){
        if (this.produtos_filtrados[index].preco_alterado){
          swal('Foram encontradas definições de desconto para o item. Estas definições serão perdidas com a utilização ' + tipo_alteracao);  
        }

        this.produtos_filtrados[index].valor_desconto = 0;
        this.produtos_filtrados[index].perc_desconto = 0;
        this.produtos_filtrados[index].desconto_alterado = false;
        this.produtos_filtrados[index].preco_alterado = false;
      },

      async utilizarPrecoAtacado(index){
        this.desfazerAlteracaoPrecoProduto(index, 'do preço de atacado!');

        this.produtos_filtrados[index].ativar_preco_atacado = !this.produtos_filtrados[index].ativar_preco_atacado;
        this.produtos_filtrados[index].usou_preco_atacado = this.produtos_filtrados[index].ativar_preco_atacado ? 'S' : 'N'; 
        this.produtos_filtrados[index].ponta_estoque = false;

        if (this.produtos_filtrados[index].usou_preco_atacado == 'S'){
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_atacado_oculto;
          this.produtos_filtrados[index].preco_base = this.produtos_filtrados[index].preco_atacado_oculto;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_atacado_oculto;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_atacado_oculto;
          this.produtos_filtrados[index].preco_venda_sem_desconto = this.produtos_filtrados[index].preco_atacado_oculto;
        } else {
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].preco_base = this.produtos_filtrados[index].preco_base_aux;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_venda_oculto_aux;
          this.produtos_filtrados[index].preco_venda_sem_desconto = this.produtos_filtrados[index].preco_aux;
        }

        if (this.parEmpQuestionarUsoPromocao == 'S') { 
          this.produtos_filtrados[index].usou_promocao = 'N';
          this.produtos_filtrados[index].usou_promocao_especial = 'N';
          this.produtos_filtrados[index].promocao = false;
        }

        await this.recalcularImpostosProdutoSelecionado([index], true);
      },

      async utilizarPontaEstoque(index){
        this.desfazerAlteracaoPrecoProduto(index, 'da ponta de estoque!');

        this.produtos_filtrados[index].ponta_estoque = !this.produtos_filtrados[index].ponta_estoque;
        this.produtos_filtrados[index].total_item_temp = 0;
        this.produtos_filtrados[index].perc_desconto_temp = 0;
        this.produtos_filtrados[index].valor_desconto_temp = 0;

        if (this.produtos_filtrados[index].ponta_estoque && this.condicaoSelecionada.permitir_uso_ponta_estoque == 'S'){
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_ponta;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_ponta;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_ponta;
          this.produtos_filtrados[index].preco_base = this.produtos_filtrados[index].preco_base_ponta;
          this.produtos_filtrados[index].estoque_ato = this.produtos_filtrados[index].qtd_disponivel_ponta_estoque;
          this.produtos_filtrados[index].estoque_agendamento = this.produtos_filtrados[index].qtd_disp_ponta_estoque_rede;
          this.produtos_filtrados[index].preco_venda_sem_desconto = this.produtos_filtrados[index].preco_ponta;
        } else {
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_venda_oculto_aux;
          this.produtos_filtrados[index].preco_base = this.produtos_filtrados[index].preco_base_aux;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].estoque_ato = this.produtos_filtrados[index].estoque_ato_aux;
          this.produtos_filtrados[index].estoque_agendamento = this.produtos_filtrados[index].estoque_agendamento_aux;
          this.produtos_filtrados[index].preco_venda_sem_desconto = this.produtos_filtrados[index].preco_aux;
        }

        if (this.parEmpQuestionarUsoPromocao == 'S') { 
          this.produtos_filtrados[index].usou_promocao = 'N';
          this.produtos_filtrados[index].usou_promocao_especial = 'N';
          this.produtos_filtrados[index].promocao = false;
        }

        await this.recalcularImpostosProdutoSelecionado([index], true);
      },

      async utilizarPromocao(index, tipo_promocao){
        this.desfazerAlteracaoPrecoProduto(index, 'da promoção' + (tipo_promocao == 'ESP' ? ' especial!' : '!'));
        
        if (this.condicaoSelecionada.aceitar_promocao_especial == 'N' && tipo_promocao == 'ESP'){
          return;
        }

        if (this.condicaoSelecionada.conceder_preco_promocional == 'N' && tipo_promocao == 'NOR'){
          return;
        }

        this.produtos_filtrados[index].promocao = !this.produtos_filtrados[index].promocao;
        this.produtos_filtrados[index].total_item_temp = 0;
        this.produtos_filtrados[index].perc_desconto_temp = 0;
        this.produtos_filtrados[index].valor_desconto_temp = 0;
        this.produtos_filtrados[index].ponta_estoque = false;

        if (this.produtos_filtrados[index].promocao){
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_promocao;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_promocao;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_promocao;
          this.produtos_filtrados[index].usou_promocao = 'S';
        } else {
          this.produtos_filtrados[index].preco = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].preco_venda_oculto = this.produtos_filtrados[index].preco_venda_oculto_aux;
          this.produtos_filtrados[index].preco_base = this.produtos_filtrados[index].preco_base_aux;
          this.produtos_filtrados[index].preco_temp = this.produtos_filtrados[index].preco_aux;
          this.produtos_filtrados[index].usou_promocao = 'N'; 
        }

        if (tipo_promocao == 'ESP'){ 
          this.produtos_filtrados[index].usou_promocao_especial = this.produtos_filtrados[index].promocao ? 'S' : 'N';
        } else if (tipo_promocao == 'NOR') {
          this.produtos_filtrados[index].usou_promocao = this.produtos_filtrados[index].promocao ? 'S' : 'N';
        }

        if (this.parEmpQuestionarUsoPrecoAtacadoVda == 'S') {
          this.produtos_filtrados[index].ativar_preco_atacado = false
          this.produtos_filtrados[index].usou_preco_atacado = 'N';
        }

        await this.recalcularImpostosProdutoSelecionado([index], true);
      },

      desabilitarOpcaoPreco(produto, tipo_preco){
        if (this.processando_imposto || produto.processando_imposto){
          return true;
        } else if ((tipo_preco == 'ATA') && (this.parEmpQuestionarUsoPrecoAtacadoVda == 'N')){
          return true;
        } else if ((tipo_preco == 'NOR') && (this.parEmpQuestionarUsoPromocao == 'N')){
          return true;
        } else if ((tipo_preco == 'ESP') && (this.parEmpQuestionarUsoPromocao == 'N')){
          return true;
        } else {
          return false;
        }
      },

      mostrarOpcaoPontaEstoque(produto){
        if 
          (
            (produto.preco_ponta > 0) &&  // Tenha preço de ponta de estoque definido.
            (produto.qtd_disponivel_ponta_estoque > 0) && // Tenha estoque disponivel na ponta de estoque.
            (!produto.ativar_preco_atacado) && // Não tenha utilizado preço de atacado.
            (produto.usou_promocao == 'N' || produto.usou_promocao_especial == 'N') && // Não está utilizando promoção normal e especial.
            (this.condicaoSelecionada.permitir_uso_ponta_estoque == 'S') // Condição de pagamento aceita uso de ponta de estoque.
          )
        {
          return true;
        }
        else {
          return false;
        }
      },

      mostrarOpcaoPrecoAtacado(produto){
        if 
          (
            (produto.preco_atacado > 0) && // Tenha preço de atacado definido.
            (produto.tipo_preco != 'NOR') && // Se o cliente utiliza preço de atacado.
            (!produto.ponta_estoque) && // Não está utilizando ponta de estoque.
            (produto.usou_promocao == 'N' || produto.usou_promocao_especial == 'N') && // Não está utilizando promoção normal e especial.
            (this.parEmpQuestionarUsoPrecoAtacadoVda == 'S') // Parâmetro para questionar uso do preço de atacado habilitado.
          )
        {
          return true;
        }
        else {
          return false;
        }
      },

      mostrarOpcaoPromocao(produto, tipo_promocao){
        if 
          (
            (!produto.ponta_estoque) && // Não está utilizando ponta de estoque.
            (!produto.ativar_preco_atacado) && // Não está utilizando preço de atacado.
            (produto.tipo_promocao != 'SEM') && // Tipo de promoção diferente de Sem promoção.
            (
              (produto.preco_promocao > 0 && produto.promocao_especial == 'N' && tipo_promocao == 'NOR') || //Promoção normal
              (produto.preco_promocao > 0 && produto.promocao_especial == 'S' && tipo_promocao == 'ESP')    //Promoção especial
            )
          )
        {
          return true;
        }
        else {
          return false;
        }
      },

      async inserirDadoPorChave(chave_pesquisa) {
        // Gravando filtros utilizados na pesquisa
        let aux_chave_produto_pesquisa = this.chave_produto_pesquisa;
        let aux_indice_produto_pesquisa = this.indice_produto_pesquisa;
        
        // Trocando filtros para buscar pelo código do produto
        this.indice_produto_pesquisa = '0';
        this.chave_produto_pesquisa =  chave_pesquisa;

        await this.buscarProdutos(true, false);
        
        // Voltando os filtros utilizados para pesquisar
        this.chave_produto_pesquisa = aux_chave_produto_pesquisa;
        this.indice_produto_pesquisa = aux_indice_produto_pesquisa;
      },

      limparPesquisa(utilizar_filtro_padrao){
        this.produtos_filtrados = [];

        if (utilizar_filtro_padrao) {
          this.indice_produto_pesquisa = 9;
          this.mostrar_filtros_produtos = true;
          this.chave_produto_pesquisa_marca = '';
          this.chave_produto_pesquisa = '';
        }
      },

      async adicionarCliente(cliente){
        await this.$emit('adicionarCliente', JSON.parse(JSON.stringify(cliente)));
        await this.limparPesquisa(true);
      },

      async limparCliente(){
        await this.$emit('limparCliente', {});
        await this.limparPesquisa(true);
      },

      async adicionarCondicaoPagamento(condicao){
        await this.$emit('adicionarCondicao', JSON.parse(JSON.stringify(condicao)));
        await this.limparPesquisa(true);
      },

      async limparCondicaoPagamento(){
        await this.$emit('limparCondicaoPagamento', {});
        await this.limparPesquisa(true);
      },

      async gravarConfiguracoesFiltros(){
        try {

          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if (!armazenamentoLocalStorage){
            armazenamentoLocalStorage = {};
          }

          let configuracoes_dispositivo_offline = armazenamentoLocalStorage.configuracoes_dispositivo_offline;

          if (!configuracoes_dispositivo_offline){
            configuracoes_dispositivo_offline = {};
          }

          configuracoes_dispositivo_offline.pesquisa_produto_orcamento = {
            questionar_multiplo_aviso_venda: !this.questionar_multiplo_aviso_venda
          }

          armazenamentoLocalStorage.configuracoes_dispositivo_offline = configuracoes_dispositivo_offline;
          
          await localStorage.setItem('localStorage', JSON.stringify(armazenamentoLocalStorage));
        } catch (error) {
          this.verificarErro(error, 'gravarConfiguracoesFiltros');     
        }
      },

      async buscarFiltrosDefinidosLocalStorage(){
        try {
          let armazenamentoLocalStorage = await JSON.parse(localStorage.getItem('localStorage'));

          if 
            (
              armazenamentoLocalStorage &&
              armazenamentoLocalStorage.configuracoes_dispositivo_offline && 
              armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_produto_orcamento
            )
          {
            let filtros = armazenamentoLocalStorage.configuracoes_dispositivo_offline.pesquisa_produto_orcamento;
            if (filtros){
              this.questionar_multiplo_aviso_venda = filtros.questionar_multiplo_aviso_venda; 
            }
          }
        } catch (error) {
          this.verificarErro(error, 'buscarFiltrosDefinidosLocalStorage');      
        }
      },

      async buscarProdutos(adicionando_direto, ver_mais){
        try {
          
          if (!this.clienteSelecionado.cadastro_id){
            Biblioteca.exclamar('Para pesquisar o preço é necessário informar o cliente!')
            return;
          }
          
          if (!this.condicaoSelecionada.condicao_id){
            Biblioteca.exclamar('Para pesquisar o preço é necessário informar a condição de pagamento!')
            return;
          }

          if (this.chave_produto_pesquisa.length == 0 && this.indice_produto_pesquisa == '0'){
            Biblioteca.exclamar("É necessário inserir um código para pesquisa!");
            document.getElementById('chave_produto_pesquisa').focus();
            return;
          }
          
          if (this.chave_produto_pesquisa.length != 0 && this.indice_produto_pesquisa == '0'){
            this.chave_produto_pesquisa = Biblioteca.numeros(this.chave_produto_pesquisa);
          }

          if (this.chave_produto_pesquisa.length == 0 && this.indice_produto_pesquisa == '2'){
            Biblioteca.exclamar("É necessário inserir um código de barras para pesquisa!");
            document.getElementById('chave_produto_pesquisa').focus();
            return;
          }
          
          if 
            (
              (this.indice_produto_pesquisa == '9') &&
              (this.chave_produto_pesquisa.length == 0 && this.chave_produto_pesquisa_marca.length == 0) 
            )
          {
            Biblioteca.exclamar("É necessário inserir um filtro para pesquisa!");
            document.getElementById('chave_produto_pesquisa').focus();
            return;
          }

          if 
            (
              (this.indice_produto_pesquisa == '9') &&
              (this.chave_produto_pesquisa.length == 0 && this.chave_produto_pesquisa_marca.length < this.parGerQtdMinCaractPesqProdutos)
            )
          {
            Biblioteca.exclamar("É necessário digitar no mínimo "  + this.parGerQtdMinCaractPesqProdutos + " caracteres de pesquisa de marca!");
            document.getElementById('chave_produto_pesquisa_marca').focus();
            return;
          }

          if 
            (
              (this.indice_produto_pesquisa == '9') && 
              (this.chave_produto_pesquisa.length < this.parGerQtdMinCaractPesqProdutos && this.chave_produto_pesquisa_marca.length == 0) 
            )
          {
            Biblioteca.exclamar("É necessário digitar no mínimo " + this.parGerQtdMinCaractPesqProdutos + " caracteres de pesquisa de nome!");
            document.getElementById('chave_produto_pesquisa').focus();
            return;
          }

          if (this.indice_produto_pesquisa == '7'){
            if (this.chave_produto_pesquisa.length < this.parGerQtdMinCaractPesqProdutos){
              Biblioteca.exclamar("É necessário digitar no mínimo " + this.parGerQtdMinCaractPesqProdutos + " caracteres de pesquisa!");
              document.getElementById('chave_produto_pesquisa').focus();
              return;
            }
                      
            let somente_caracter_coriga = true
            for (let i = 0; i < this.chave_produto_pesquisa.length; i++){
              somente_caracter_coriga = (this.chave_produto_pesquisa[i] == '%')

              if (!somente_caracter_coriga){
                break
              }
            }

            if (somente_caracter_coriga){
              Biblioteca.exclamar('Este tipo de pesquisa não permite utilizar somente caracteres coringa!')
              return;
            }
          } else if (this.indice_produto_pesquisa == '9'){
            
            if 
              (
                (this.chave_produto_pesquisa.length < this.parGerQtdMinCaractPesqProdutos) && 
                (this.chave_produto_pesquisa_marca.length < this.parGerQtdMinCaractPesqProdutos)
              )
            {
              Biblioteca.exclamar("É necessário digitar no mínimo " + this.parGerQtdMinCaractPesqProdutos + " caracteres de pesquisa!");
              document.getElementById('chave_produto_pesquisa').focus();
              return;
            }
                      
            let somente_caracter_coriga = true;
            for (let i = 0; i < this.chave_produto_pesquisa.length; i++){
              somente_caracter_coriga = (this.chave_produto_pesquisa[i] == '%');

              if (!somente_caracter_coriga){
                break;
              }
            }

            if (somente_caracter_coriga){
              for (let i = 0; i < this.chave_produto_pesquisa_marca.length; i++){
                somente_caracter_coriga = (this.chave_produto_pesquisa_marca[i] == '%');

                if (!somente_caracter_coriga){
                  break;
                }
              }  
            }

            if (somente_caracter_coriga){
              Biblioteca.exclamar('Este tipo de pesquisa não permite utilizar somente caracteres coringa!');
              return;
            }
          }

          this.processando = true;

          if (!ver_mais){
            this.produtos_filtrados = [];
            this.produtos_ja_mostrados_ids = [];
          }

          let parametros = {
            indice_pesquisa: this.indice_produto_pesquisa,
            chave_pesquisa: this.chave_produto_pesquisa,
            chave_marca: this.chave_produto_pesquisa_marca,
            condicao_pagamento_id: this.condicaoSelecionada.condicao_id,
            cliente_id: this.clienteSelecionado.cadastro_id,
            bairro_id: this.enderecoClienteSelecionado.bairro_id,
            cep: this.enderecoClienteSelecionado.cep,
            tipo_imovel: this.enderecoClienteSelecionado.tipo_imovel,
            andar: this.enderecoClienteSelecionado.andar,
            inscricao_estadual: this.enderecoClienteSelecionado.inscricao_estadual,
            outras_despesas: this.outrasDespesas,
            total_produtos: this.totalProdutos,
            total_frete: this.totalFrete,
            tipo_frete: this.tipoFrete,
            valor_frete: this.valorFrete,
            tipo_entrega: this.tipoEntrega,
            usou_indice_grupo_indice_preco: 'N',
            qtd_produtos_por_pagina: this.qtd_produtos_por_pagina,
            produtos_ja_mostrados_ids: ver_mais ? this.produtos_ja_mostrados_ids : []
          }

          let retorno = await RProdutoBuscarProdutoOrcamento.buscarProdutosOrcamento(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.processando = false;
            
          for (let i = 0; i < retorno.dados.produtos.length; i++) {
            retorno.dados.produtos[i].adicionado = false;
            retorno.dados.produtos[i].usou_promocao = 'N';
            retorno.dados.produtos[i].usou_promocao_especial = 'N';
            retorno.dados.produtos[i].quantidade = 0;
            retorno.dados.produtos[i].perc_desconto = 0;
            retorno.dados.produtos[i].valor_desconto = 0;

            retorno.dados.produtos[i].produto_id = Biblioteca.valorInt(retorno.dados.produtos[i].produto_id);
            retorno.dados.produtos[i].preco = Biblioteca.valor(retorno.dados.produtos[i].preco);
            retorno.dados.produtos[i].preco_base = Biblioteca.valor(retorno.dados.produtos[i].preco_base);
            retorno.dados.produtos[i].preco_atacado = Biblioteca.valor(retorno.dados.produtos[i].preco_atacado);
            retorno.dados.produtos[i].preco_ponta = Biblioteca.valor(retorno.dados.produtos[i].preco_ponta);
            retorno.dados.produtos[i].preco_atacado_oculto = Biblioteca.valor(retorno.dados.produtos[i].preco_atacado_oculto);
            retorno.dados.produtos[i].preco_promocao = Biblioteca.valor(retorno.dados.produtos[i].preco_promocao);
            retorno.dados.produtos[i].preco_base_promocao = Biblioteca.valor(retorno.dados.produtos[i].preco_base_promocao);
            retorno.dados.produtos[i].qtd_disponivel_ponta_estoque = Biblioteca.valor(retorno.dados.produtos[i].qtd_disponivel_ponta_estoque);
            retorno.dados.produtos[i].qtd_disp_ponta_estoque_rede = Biblioteca.valor(retorno.dados.produtos[i].qtd_disp_ponta_estoque_rede);
            retorno.dados.produtos[i].estoque_ato = Biblioteca.valor(retorno.dados.produtos[i].estoque_ato);
            retorno.dados.produtos[i].estoque_agendamento = Biblioteca.valor(retorno.dados.produtos[i].estoque_agendamento);
            retorno.dados.produtos[i].estoque_ato = retorno.dados.produtos[i].estoque_ato - retorno.dados.produtos[i].qtd_disponivel_ponta_estoque;
            retorno.dados.produtos[i].estoque_agendamento = retorno.dados.produtos[i].estoque_agendamento - retorno.dados.produtos[i].qtd_disp_ponta_estoque_rede;
            retorno.dados.produtos[i].preco_manual = 0;
            retorno.dados.produtos[i].preco_venda_oculto = retorno.dados.produtos[i].preco;
            retorno.dados.produtos[i].preco_unitario_com_imposto = Biblioteca.valor(retorno.dados.produtos[i].preco_unitario_com_imposto);

            retorno.dados.produtos[i].perc_desconto_temp = '';
            retorno.dados.produtos[i].valor_desconto_temp = 0;
            retorno.dados.produtos[i].total_item_temp = 0;
            retorno.dados.produtos[i].preco_temp = retorno.dados.produtos[i].preco;              
            retorno.dados.produtos[i].valor_total_ipi = 0;
            retorno.dados.produtos[i].valor_total_st = 0;              
            retorno.dados.produtos[i].ponta_estoque = (retorno.dados.produtos[i].preco_ponta > 0);

            retorno.dados.produtos[i].quantidade_entrega_ato = 0;
            retorno.dados.produtos[i].quantidade_agendar = 0;
            retorno.dados.produtos[i].retirar_lojas_rede = 'N';
            retorno.dados.produtos[i].empresa_retirar_lojas_rede_id = 0;
            retorno.dados.produtos[i].quantidade_sem_previsao = 0;

            retorno.dados.produtos[i].tipo_selec_local_entrega_ato = 'N';
            retorno.dados.produtos[i].quantidade_entrega_ato_loj = 0;
            retorno.dados.produtos[i].quantidade_entrega_ato_dep = 0;
            retorno.dados.produtos[i].quantidade_entrega_ato_exp = 0;
            retorno.dados.produtos[i].tipo_local_padrao_entrega_ato = 'N';
            retorno.dados.produtos[i].qtd_sem_agendamento = 0;
            retorno.dados.produtos[i].previsao_entrega_sem_agen = 0;

            retorno.dados.produtos[i].ponta_estoque = false;
            retorno.dados.produtos[i].promocao = false;
            retorno.dados.produtos[i].ativar_preco_atacado = false;
            retorno.dados.produtos[i].recalcular_preco_imposto = false;
            retorno.dados.produtos[i].quantidade_edicao = '';

            retorno.dados.produtos[i].foi_adicionado = false;
            for (let j = 0; j < this.produtosSelecionados.length; j++){
              if (retorno.dados.produtos[i].produto_id == this.produtosSelecionados[j].produto_id){
                retorno.dados.produtos[i].foi_adicionado = true;
                break;
              }
            }

            // Parâmetros de questionar uso do preço de atacado 
            if
              (
                (retorno.dados.produtos[i].preco_atacado > 0) &&
                (retorno.dados.produtos[i].tipo_preco != 'NOR') &&
                (this.parEmpQuestionarUsoPrecoAtacadoVda == 'N')
              )
            {
              retorno.dados.produtos[i].usou_preco_atacado = 'S';
              retorno.dados.produtos[i].usou_promocao = 'N'; 
              retorno.dados.produtos[i].ativar_preco_atacado = false;
              retorno.dados.produtos[i].preco = retorno.dados.produtos[i].preco_atacado_oculto;
              retorno.dados.produtos[i].preco_venda_oculto = retorno.dados.produtos[i].preco_atacado_oculto;
              retorno.dados.produtos[i].recalcular_preco_imposto = true;
            // Regra para não questionar uso da promoção 
            } else if 
              (
                (this.parEmpQuestionarUsoPromocao == 'N') && 
                (retorno.dados.produtos[i].preco_promocao > 0)
              ) 
            {
              retorno.dados.produtos[i].preco = retorno.dados.produtos[i].preco_promocao;
              retorno.dados.produtos[i].preco_venda_oculto = retorno.dados.produtos[i].preco_promocao;
              retorno.dados.produtos[i].preco_temp = retorno.dados.produtos[i].preco_promocao;
              retorno.dados.produtos[i].promocao = true;
              retorno.dados.produtos[i].recalcular_preco_imposto = true;
              retorno.dados.produtos[i].preco_unitario_com_imposto = retorno.dados.produtos[i].preco_promocao;
              retorno.dados.produtos[i].preco_base = retorno.dados.produtos[i].preco_base_promocao;

              if (retorno.dados.produtos[i].promocao_especial == 'S'){
                retorno.dados.produtos[i].usou_promocao_especial = 'S'
              } else {
                retorno.dados.produtos[i].usou_promocao = 'S';
              }
            }

            // Armazendo os preço por causa da ponta de estoque
            retorno.dados.produtos[i].preco_aux = retorno.dados.produtos[i].preco;
            retorno.dados.produtos[i].preco_venda_oculto_aux = retorno.dados.produtos[i].preco_venda_oculto;
            retorno.dados.produtos[i].preco_unitario_com_imposto_aux = retorno.dados.produtos[i].preco_unitario_com_imposto;
            retorno.dados.produtos[i].preco_base_aux = retorno.dados.produtos[i].preco_base;
            retorno.dados.produtos[i].estoque_ato_aux = retorno.dados.produtos[i].estoque_ato;
            retorno.dados.produtos[i].estoque_agendamento_aux = retorno.dados.produtos[i].estoque_agendamento;

            this.produtos_filtrados.push(JSON.parse(JSON.stringify(retorno.dados.produtos[i])));
            this.produtos_ja_mostrados_ids.push(retorno.dados.produtos[i].produto_id);
          }

          if (this.condicaoSelecionada.utilizar_tac_somente_simulacao == 'N') {
            this.valor_tac = parseFloat(retorno.dados.valor_tac);
          } else {
            this.valor_tac = 0;
          }
          
          this.valor_total_st_frete = retorno.dados.valor_st_frete;

          this.mostrar_botao_ver_mais = retorno.dados.tem_continuacao == 'S';
          this.total_paginas = Math.ceil(this.produtos_filtrados.length / this.qtd_produtos_por_pagina);
          
          if (adicionando_direto){
            this.mostrarModalProdutos(true);
            this.produtos_filtrados[0].mostrar_detalhes = true;
            this.produtos_filtrados[0].recalcular_preco_imposto = false;
          } else {
            // Incrementado mais uma página se estiver vendo mais.
            if (ver_mais) {
              this.pagina_atual++;
            } else {
              this.pagina_atual = 1; 
            }
          }

          this.mostrar_filtros_produtos = false;
            
          if (this.indice_produto_pesquisa == 0 || this.indice_produto_pesquisa == 2){ 
            this.chave_produto_pesquisa = '';
          }
        } catch (error) {
          this.verificarErro(error, 'buscarProdutos');  
        }
      },

      verificarErro(erro, nome_funcao){
        this.processando = false;
        this.processando_imposto = false;
        this.mostrar_filtros_produtos = true;
        this.produtos_filtrados = [];
        Biblioteca.gerarLogNomeFuncao('PesquisaProdutosVenda.vue -> ' + nome_funcao);
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },
    },
}
</script>
<style scoped>
  .card-mensagem:hover { background-color: #fff !important }
  .card-mensagem:hover label{ color: #9c1d1c !important; }
  .card-mensagem:hover p,
  .card-mensagem:hover span{color: #636363 !important}

  h2{
    border-bottom: 1px solid #9c1d1c;
  }

  @media screen and (max-width: 490px){
    #tabPrincipais div span:first-of-type{
      margin-bottom: 0px !important;
    }
  }

  @media screen and (min-width: 1200px){slider
    .bloco-consumidor-final button{
      margin-left: 10px !important;
      margin-top:20px !important;
      height: 42px;
    }

    .bloco-consumidor-final div{
      width: calc(100% - 8.33333% - 10px);
    }

    .card-produto button:hover{
      background-color: #9c1d1c !important;
      color: #fff !important;
      box-shadow: 0px 2px 32px #00000090;
    }
  }
  @media screen and (max-width: 767px){
    .margin-0-mobile{
      margin-top: 0px !important;
    }
    .card-produto{
      margin:10px 0 !important;
    }
    h2{
      font-size: 24px;
      margin-bottom:15px;
    }
    h5 {
      margin-left: 0 !important;
    }
    #principal > .w3-container{
      padding:0 !important;
    }

    .fechar-pedido{
      width: calc(100% - 32px);
      margin: 0 16px;
    }

    .div-btn-filtro {
      margin-top: 0 !important;
      margin-bottom: 16px;
    }

    .padding-info {
      padding: 0;
    }

    .recebimento-mobile {
      margin-top: 16px !important;
      text-align: center;
    }

    .table-entrega-ato .max-width .check-no-ato {
      width: 18px !important;
      padding: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }

  .w3-modal {
    padding-top: 60px !important;
    padding-bottom: 10px;
  }

  .disable {
    opacity: 0.5
  }

  .enable {
    opacity: 1
  }

  #tam_nome_prod:focus { 
    text-align: left;
  }

  #tam_nome_prod { 
    text-align: right;
  }

  .switch-input {
    display: none;
  }

  .max-width {
    height: 42px
  }

  .input-entra-ato {
    color: rgb(55, 128, 55);
    text-align: center;
    cursor: pointer;
    
    border-bottom: none;
    border-color: transparent;
    background-color: rgba(144, 238, 144, 0.21);

    width: 100% !important;
    height: 100% !important;
  }

  .input-entra-ato:focus {
    border-color: rgb(50, 156, 50);
    outline: none;
    border-bottom: 2px solid;
    -webkit-appearance: none;
  }

  .sem-agendamento {
    background-color: #ff000021; 
    color: red;     
  }

  .check-no-ato {
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .hide-data-previsao {
    display: none;
  }

  .drop-down-ato {
    padding: 5px;
    cursor: default !important;     
    margin-bottom: 5px  ;  
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;     
    width: 315px !important;
  }

  .dropdown-esquerda{
    right:0 !important;
  }

  .tr-items:hover {
	  background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }
  .tr-items-ativo:hover {
    background: #9c1d1c;
    color: white;
  }
  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  } 

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar:horizontal {
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }

  .card-produto{
    background-color: #ebebeb;
    border: 2px solid #ebebeb;
    padding: 10px;
    border-radius: 20px;
  }

  .card-produto.active{
    background: #ebebeb;
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }

  .card-item {
    margin-top: 0 !important
  }

  .legenda-redonda {    
    padding: 5px;
    border-radius: 15px;  
  }

  .botoes-cinza {
    border: 1px solid #bdb7b8;
    color: #9c1d1c;
  }
  .total-pedido-detalhes{
    color: black;
    z-index:50;
  }

  .botao-tipo-entrega {
    padding: 5px 0 5px 0; 
    width: 98%;
    border-radius: 20px;
    outline: 0;
    background-image: linear-gradient(to right, #dddddd, #cccccc);
    color: #000000;
    border: 1px solid #aaaaaa;
    cursor: pointer;
  }

  .botao-tipo-entrega-selecionado {
    background-image: linear-gradient(to right, #9c1d1c, #691212);
    color: #ffffff;
    border: 1px solid #cccccc;
  }

  .botao-consumidor-final {
    margin-top: 23px;
  }

  #eQuantidadeProduto, .btn-qtd{
    height: 30px !important;
    padding: 0 10px !important;
    font-size: 14px;
  }

  .link{
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;  
  }
  
  .switch{
    width:100px;
    height: 14px;
  }

  .slider.round {
    border-radius: 34px;
    padding-top: 1px;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }
  
  input:checked+.slider {
    background-color: rgb(3, 0, 255);
    color:white;
  }
  
  input:checked+.slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
  
  .slider-promocao.round-promocao {
    border-radius: 34px;
    padding-top: 1px;
  }
  
  .slider-promocao {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider-promocao.round-promocao:before {
    border-radius: 50%;
  }
  
  .slider-promocao:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }
  
  input:checked+.slider-promocao {
    background-color: #3d9442;
    color:white;
  }
  
  input:checked+.slider-promocao:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  .slider-promocao-especial.round-promocao-especial {
    border-radius: 34px;
    padding-top: 1px;
  }
  .slider-promocao-especial {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider-promocao-especial.round-promocao-especial:before {
    border-radius: 50%;
  }
  
  .slider-promocao-especial:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }
  
  input:checked+.slider-promocao-especial {
    background-color: #9c27b0;
    color:white;
  }
  
  input:checked+.slider-promocao-especial:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  .slider-atacado.round-atacado {
    border-radius: 34px;
    padding-top: 1px;
  }
  
  .slider-atacado {
    position: absolute;
    cursor: pointer;
    top: 0;
    font-size: 14px;
    left: 0;
    right: 0;
    bottom: 2px;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider-atacado.round-atacado:before {
    border-radius: 50%;
  }
  
  .slider-atacado:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: #636363 1px 1px 0px 0px;
  }
  
  input:checked+.slider-atacado{
    background-color: rgb(168, 24, 62);
    color:white;
  }
  
  input:checked+.slider-atacado:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
</style>


// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaProdutosVenda.vue